import {QxQueue} from './QxQueue';

export const q = new QxQueue().next;
